// src/pages/PersonalPage.jsx

import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import PersonalConversation from "../components/PersonalConversation";

const API_BASE = "http://localhost:4000";
//const API_BASE = "https://myjourneytrails.com";

export default function PersonalPage() {
  const { conversationId } = useParams();

  const [messages, setMessages] = useState([]);
  const [userName, setUserName] = useState("You");
  const [sessionEnded, setSessionEnded] = useState(false);

  // Load initial messages
  useEffect(() => {
    async function load() {
      const res = await fetch(`${API_BASE}/api/personal/${conversationId}`, {
        credentials: "include"
      });
      const data = await res.json();

      setMessages(data.messages || []);
    }
    load();
  }, [conversationId]);

  return (
    <div className="page-wrap">
      <PersonalConversation
        conversationId={conversationId}
        messages={messages}
        setMessages={setMessages}
        userName={userName}
        sessionEnded={sessionEnded}
      />
    </div>
  );
}
